import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BoltMotionIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M16.9887 10.0684L18.6207 2.5H16.1115L6.07471 13.924H13.0107L11.3787 21.4924H13.8879L23.9247 10.0684H16.9887ZM16.5603 4.3972L14.9895 11.5372H20.4771L13.4391 19.5952L15.0099 12.4552H9.52231L16.5603 4.3972ZM5.4 11.6669H0V13.2269H5.4V11.6669ZM2.4 8.06689L7.8 8.06689V9.62689H2.4V8.06689ZM7.8 15.2669H2.4V16.8269H7.8V15.2669Z"
      />
    </SvgIcon>
  );
});
